import jsPDF from "jspdf";
import "jspdf-autotable";

import {
    GET_ERP_IMG,
    loginUserDetails,
    getFixedNumber,
    getDateTime_dmy,
    GET_COMPANY_FROM_URL
} from "../../components/Common/CommonFunction";


// ------------------ MONTH HELPERS --------------------



const ALL_MONTHS = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];

function buildRotatedMonths(startMonthIndex) {
    
    const arr = [];

    for (let i = 0; i < 12; i++) {
        arr.push(ALL_MONTHS[(startMonthIndex + i) % 12]);
    }

    return arr;
}

function formatDMY(dateStr) {
    if (!dateStr) return "";

    const d = new Date(dateStr);

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    return `${day}/${month}/${year}`;
}


// ----------------------------------------------------


const AnnualItemSalePDF = (data, config = {}) => {

    
    const doc = new jsPDF("l", "pt", "a4");
    // get request params safely
    let req = {};

    if (config.jsonBody) {
        req = JSON.parse(config.jsonBody);
    } else if (data?.[0]?.Period?.jsonBody) {
        req = JSON.parse(data[0].Period.jsonBody);
    } else {
        req = config;
    }

    const fromDate = new Date(req.FromDate);
    const toDate = new Date(req.ToDate);

    console.log("REQ:", req);
    console.log("MONTH RANGE:", fromDate, toDate);


    const startMonthIndex = fromDate.getMonth();

    //  HEADER MONTHS
    const visibleMonths = buildRotatedMonths(startMonthIndex);

    
    // ------------------ BORDER --------------------

    function drawBorder() {
        doc.setDrawColor(0);
        doc.setLineWidth(1.3);   //  thickness 
        doc.rect(15, 15, 810, 545);

    }


    // ------------------ HEADER --------------------

    const pageHeader = () => {

        const user = loginUserDetails();

        const pageWidth = doc.internal.pageSize.getWidth();

        // 🟢 CENTER BIG LOGO
        const logoWidth = 130;
        const logoHeight = 45;

        const logoX = (pageWidth / 2) - (logoWidth / 2);

        // doc.addImage(
        //     GET_ERP_IMG().Logo,
        //     "PNG",
        //     logoX,
        //     23,
        //     logoWidth,
        //     logoHeight
        // );


        const logo = localStorage.getItem(
            `${GET_COMPANY_FROM_URL()}_CompanyLogo`
        );
        
        if (logo) {
            doc.addImage(
                logo,
                "PNG",
                logoX,
                23,
                logoWidth,
                logoHeight
            );
        }


        // 🟢 RIGHT SIDE TITLE
        doc.setFontSize(13);
        doc.setFont(undefined, "bold");

        doc.text(
            "Annual Item Sale Report",
            pageWidth - 25,
            40,
            { align: "right" }
        );

        // 🟢 RIGHT SIDE DATE RANGE
        doc.setFontSize(9);

        doc.text(
            `From ${formatDMY(req.FromDate)} To ${formatDMY(req.ToDate)}`,
            pageWidth - 25,
            58,
            { align: "right" }
        );

        // 🟢 LEFT PARTY DETAILS
        doc.setFontSize(9);
        doc.text(`Party : ${user.PartyName}`, 25, 40);
        doc.text(`Address : ${user.PartyAddress}`, 25, 60);

    };

    const pageFooter = () => {

        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        doc.setFontSize(8);
        doc.setFont(undefined, "normal");

        doc.text(
            `Printed On : ${getDateTime_dmy()}`,
            25,                   //  LEFT inside border
            pageHeight - 22,
            { align: "left" }
        );

    };

    // ------------------ GROUPING --------------------

    const grouped = {};

    data.forEach(row => {
        
        const invDate = new Date(row.InvoiceDate);

        if (invDate < fromDate || invDate > toDate) return;

        const monthName = ALL_MONTHS[invDate.getMonth()];

        if (!grouped[row.ItemName]) {
            grouped[row.ItemName] = {};
        }

        if (!grouped[row.ItemName][monthName]) {
            grouped[row.ItemName][monthName] = {
                Kg: 0,
                Basic: 0,
                GST: 0,
                Grand: 0,
                Rate: row.Rate || 0
            };
        }

        const rec = grouped[row.ItemName][monthName];

        rec.Kg += row.QtyInKg || 0;
        rec.Basic += row.BasicAmount || 0;
        rec.GST += row.GSTAmount || 0;
        rec.Grand += row.GrandTotal || 0;

    });


    // ------------------ TABLE HEADER --------------------

    const tableHead = [
        ["Item Name", ...visibleMonths, "Total", "UOM"]
    ];



    // ------------------ TABLE BODY --------------------

    const tableBody = [];

    Object.entries(grouped).forEach(([item, months]) => {

        const rows = {
            Kg: [],
            Rs1: [],
            GST: [],
            Rs2: [],
            Rate: []
        };


        let totals = {
            Kg: 0,
            Rs1: 0,
            GST: 0,
            Rs2: 0,

        };

        visibleMonths.forEach(m => {

            const rec = months[m];

            if (rec) {

                rows.Kg.push(getFixedNumber(rec.Kg, 2));
                rows.Rs1.push(Number(getFixedNumber(rec.Basic, 2)).toFixed(2));
                rows.GST.push(Number(getFixedNumber(rec.GST, 2)).toFixed(2));
                rows.Rs2.push(Number(getFixedNumber(rec.Grand, 2)).toFixed(2));


                rows.Rate.push(rec.Rate ? rec.Rate.toFixed(2) : "");


                totals.Kg += rec.Kg;
                totals.Rs1 += rec.Basic;
                totals.GST += rec.GST;
                totals.Rs2 += rec.Grand;


            } else {

                rows.Kg.push("");
                rows.Rs1.push("");
                rows.GST.push("");
                rows.Rs2.push("");
                rows.Rate.push("0.00");
            }
        });


        // -------- TOTAL COLUMN ---------

        rows.Kg.push(getFixedNumber(totals.Kg, 2));
        rows.Rs1.push(Number(getFixedNumber(totals.Rs1, 2)).toFixed(2));
        rows.GST.push(Number(getFixedNumber(totals.GST, 2)).toFixed(2));
        rows.Rs2.push(Number(getFixedNumber(totals.Rs2, 2)).toFixed(2));

        //  pick first available rate for total column
        // let totalRate = "";

        // visibleMonths.some(m => {
        //     if (months[m] && months[m].Rate) {
        //         totalRate = months[m].Rate.toFixed(2);
        //         return true;
        //     }
        //     return false;
        // });

        // rows.Rate.push(totalRate);

        //  RATE TOTAL COLUMN → BLANK
        rows.Rate.push("");



        // -------- UOM COLUMN ---------

        rows.Kg.push("Kg");
        rows.Rs1.push("Rs");
        rows.GST.push("GST");
        rows.Rs2.push("Rs");
        rows.Rate.push("Rate");


        // -------- PUSH ROWS ----------

        tableBody.push([item, ...rows.Kg, "Kg"]);
        tableBody.push(["", ...rows.Rs1, "Rs"]);
        tableBody.push(["", ...rows.GST, "GST"]);
        tableBody.push(["", ...rows.Rs2, "Rs"]);
        tableBody.push(["", ...rows.Rate, "Rate"]);

    });



    // ------------------ AUTOTABLE --------------------

    const totalColIndex = visibleMonths.length + 1;
    const uomColIndex = visibleMonths.length + 2;

    doc.autoTable({

        head: tableHead,
        body: tableBody,

        startY: 90,

        margin: {
            left: 15,
            right: 20,
            bottom: 25,

        },


        theme: "grid",

        pageBreak: "auto",

        styles: {
            fontSize: 7,
            halign: "right",
            valign: "middle",
            lineWidth: 0.6,
            lineColor: [90, 90, 90]

        },

        headStyles: {
            fillColor: [255, 255, 255],
            textColor: 0,
            fontStyle: "bold",
            halign: "center",
            lineWidth: 1,
            lineColor: [0, 0, 0] 
        },

        bodyStyles: {
            textColor: [0, 0, 0],
            fontSize: 7
        },

        columnStyles: {
            0: { cellWidth: 95, halign: "left" },
            [totalColIndex]: { cellWidth: 55 },
            [uomColIndex]: { cellWidth: 40 }
        },

        didDrawPage: function (data) {

            drawBorder();
            pageFooter();

            if (data.pageNumber === 1) {
                pageHeader();
            }
        },



        didParseCell: function (data) {

            if (data.section !== "body") return;
        
            // 🟢 MAIN Item row (each block of 5)
            if (
                data.column.index === 0 &&
                data.row.index % 5 === 0
            ) {
                data.cell.rowSpan = 5;
                data.cell.styles.valign = "middle";
                data.cell.styles.fontStyle = "bold";
            }
        
            // Below 4 rows → blank item column
            if (
                data.column.index === 0 &&
                data.row.index % 5 !== 0
            ) {
                data.cell.text = "";
                data.cell.styles.lineWidth = 0;
                data.cell.styles.lineColor = [255,255,255];
            }
        
            // total column bold
            if (data.column.index === totalColIndex) {
                data.cell.styles.fontStyle = "bold";
            }
        
        
        
        },
        

        didDrawCell: function (data) {

            if (data.section !== "body") return;

            //  Kg row start (item block start)
            if (
                data.row.index % 5 === 0 &&
                data.column.index === uomColIndex   //  draw after full row
            ) {
                const { doc } = data;

                const left = data.table.settings.margin.left;
                const right =
                    doc.internal.pageSize.getWidth() -
                    data.table.settings.margin.right;

                const y = data.cell.y;

                doc.setDrawColor(0, 0, 0);
                doc.setLineWidth(1);

                doc.line(left, y, right, y);
            }

        },


    });


    // ---------------- PAGE NUMBERS ----------------

    const pageCount = doc.internal.getNumberOfPages();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    for (let i = 1; i <= pageCount; i++) {

        doc.setPage(i);

        doc.setFontSize(8);

        doc.text(
            `Page ${i} of ${pageCount}`,
            pageWidth - 25,     //  inside border
            pageHeight - 22,
            { align: "right" } //  RIGHT only
        );
    }





    window.open(doc.output("bloburl"));
};

export default AnnualItemSalePDF;
